export const facilityTypes = [
  { value: "vets", label: "Veterinarian" },
  { value: "urgentcare", label: "Urgent Care" },
  { value: "pharmacies", label: "Pharmacies" },
  { value: "hospitals", label: "Hospital" }
];
